/**
 * App 主线包列表页面
 */

import React from 'react'
import Dialog from '@tencent/spaui-dialog'
import useOperationBind from './hooks/useOperationBind'
import DialogAppInfo from 'pureComponents/DialogAppInfo'
import DialogUploadTypeRadioGroup from 'pureComponents/DialogUploadTypeRadioGroup'
import Input from '@tencent/spaui-input'
import AlertTips from 'pureComponents/AlertTips'
import { OPERATION_AD_TYPE, ACCOUNT_TYPE } from '../OperationList/constants'

const OperationAddDialog = props => {
    const { appInfo } = props
    const {
        handleSubmit,
        disableSubmit,
        submitInfo,
        setType,
        setAccount,
        setServiceProviderId,
        setIds,
        reset,
        error,
    } = useOperationBind(props)
    const onCancelClick = () => {
        props.onClose && props.onClose()
        reset()
    }

    return (
        <Dialog
            className="track-dialog"
            onSubmit={handleSubmit}
            title="绑定投放账户"
            style={{
                width: '500px',
            }}
            type="normal"
            submitLabel={disableSubmit ? '提交中...' : '确定'}
            disabled={disableSubmit}
            backdrop
            {...props}
            onClose={onCancelClick}
            onCancel={onCancelClick}
        >
            <div className="track-body-item">
                <DialogAppInfo label="APP名称：" name={appInfo.name || ''} desc={`（应用ID：${appInfo.openAppId}）`} />
            </div>
            {error ? (
                <div className="track-body-item">
                    <AlertTips type="error" icon="warn">
                        {error}
                    </AlertTips>
                </div>
            ) : null}
            <DialogUploadTypeRadioGroup
                data={[
                    { value: OPERATION_AD_TYPE.KA, children: '应用宝代理' },
                    { value: OPERATION_AD_TYPE.DIRECT, children: '腾讯广告投放' },
                ]}
                label="绑定类型"
                value={submitInfo.type}
                onChange={val => setType(val)}
            />
            <DialogUploadTypeRadioGroup
                data={[
                    { value: ACCOUNT_TYPE.SERVICE_PROVIDER, children: '服务商' },
                    { value: ACCOUNT_TYPE.DIRECT, children: '直客' },
                ]}
                label="投放帐户类型："
                vertical={true}
                value={submitInfo.selectAccount}
                onChange={val => setAccount(val)}
            />
            {submitInfo.showInput ? (
                <Input
                    type="number"
                    value={submitInfo.serviceProviderId}
                    placeholder="服务商id"
                    style={{ width: '180px' }}
                    onChange={(_, val) => setServiceProviderId(val)}
                ></Input>
            ) : (
                <></>
            )}

            <div className="track-body-item">
                <DialogAppInfo label="投入账户ID：" />
                <Input
                    tagType="textarea"
                    value={submitInfo.ids}
                    onChange={(_, val) => setIds(val)}
                    placeholder={
                        submitInfo.type === OPERATION_AD_TYPE.KA
                            ? '请输入单个账号ID'
                            : '请输入账户ID,多个账户可以用(,)分隔'
                    }
                ></Input>
            </div>
            <p className="operation-add-dialog-tip-mt">1、仅支持AMS投放账号</p>
            <p>2、腾讯广告投放账户类型可绑定多个账号</p>
            <p>3、多账号输入使用英文逗号(,)间隔</p>
        </Dialog>
    )
}

export default OperationAddDialog
